import { render, staticRenderFns } from "./staffManagement.vue?vue&type=template&id=d7188942&scoped=true"
import script from "./staffManagement.vue?vue&type=script&lang=js"
export * from "./staffManagement.vue?vue&type=script&lang=js"
import style0 from "./staffManagement.vue?vue&type=style&index=0&id=d7188942&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7188942",
  null
  
)

export default component.exports